<template>
</template>
<script>
  export default {
    name: "listener",
    created() {
      this.initListener();
    },
    destroyed() {
      this.removeListener();
    },
    methods: {
      initListener: function () {
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.INVITED,
          (params = {}) => {
            this.$emit("handleNewInvitationReceived", {...params})
          }
        );
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.USER_ACCEPT,
          (params = {}) => {
            this.$emit("handleUserAccept", {...params})
          }
        );
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.USER_ENTER,
          (params = {}) => {
            this.$emit("handleUserEnter", {...params})
          }
        );
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.REJECT,
          (params = {}) => {
            this.$emit("handleInviteeReject", {...params})
          }
        );
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.LINE_BUSY,
          (params = {}) => {
            this.$emit("handleInviteeLineBusy", {...params})
          }
        );
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.CALLING_TIMEOUT,
          (params = {}) => {
            this.$emit("handleCallTimeout", {...params})
          }
        );
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.NO_RESP,
          (params = {}) => {
            this.$emit("handleNoResponse", {...params})
          }
        );
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.CALLING_END,
          (params = {}) => {
            this.$emit("handleCallEnd", {...params})
          }
        );
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.USER_VIDEO_AVAILABLE,
          (params = {}) => {
            this.$emit("handleUserVideoChange", {...params})
          }
        );
        this.$trtcCalling.on(
          this.TRTCCalling.EVENT.USER_AUDIO_AVAILABLE,
          (params = {}) => {
            this.$emit("handleUserAudioChange", {...params})
          }
        );
        this.$tim.on(
          this.TIM.EVENT.SDK_READY,
          (params = {}) => {
            this.$emit("ready", {...params})
          }
        );
      },
      removeListener: function () {
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.INVITED,
          (params = {}) => {
            this.$emit("handleNewInvitationReceived", {...params})
          }
        );
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.USER_ACCEPT,
          (params = {}) => {
            this.$emit("handleUserAccept", {...params})
          }
        );
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.USER_ENTER,
          (params = {}) => {
            this.$emit("handleUserEnter", {...params})
          }
        );
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.REJECT,
          (params = {}) => {
            this.$emit("handleInviteeReject", {...params})
          }
        );
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.LINE_BUSY,
          (params = {}) => {
            this.$emit("handleInviteeLineBusy", {...params})
          }
        );
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.CALLING_TIMEOUT,
          (params = {}) => {
            this.$emit("handleCallTimeout", {...params})
          }
        );
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.NO_RESP,
          (params = {}) => {
            this.$emit("handleNoResponse", {...params})
          }
        );
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.CALLING_END,
          (params = {}) => {
            this.$emit("handleCallEnd", {...params})
          }
        );
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.USER_VIDEO_AVAILABLE,
          (params = {}) => {
            this.$emit("handleUserVideoChange", {...params})
          }
        );
        this.$trtcCalling.off(
          this.TRTCCalling.EVENT.USER_AUDIO_AVAILABLE,
          (params = {}) => {
            this.$emit("handleUserAudioChange", {...params})
          }
        );
        this.$tim.off(
          this.TRTCCalling.EVENT.SDK_READY,
          (params = {}) => {
            this.$emit("ready", {...params})
          }
        );
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TrtcCall/listener.vue